(function() {
    angular
        .module("devicesModule")
        .controller("DeviceMessageBoardDetailsController", DeviceMessageBoardDetailsController)

    DeviceMessageBoardDetailsController.$inject = [
        "$rootScope",
        "$scope",
        "$stateParams",
        "$uibModal",
        "devicesService",
        "messageBoardsService",
        "messagePreviewService",
        "telemetryService",
        "notesService",
        "userMessagingService"
    ]

    function DeviceMessageBoardDetailsController(
        $rootScope,
        $scope,
        $stateParams,
        $uibModal,
        devicesService,
        messageBoardsService,
        messagePreviewService,
        telemetryService,
        notesService,
        userMessagingService
    ){
        "use strict"

        /**
            $scope variables
         **/
        $scope.generalFormData     = {}
        $scope.connectionFormData  = {}
        $scope.enableAlerts        = true
        $scope.ignoreDuplicateIPs = false

        $scope.activeUseInWZ    = false
        $scope.inEnabledWZ      = false
        $scope.disableDOTAccess = false

        $scope.transportOptions    = [
            {id: "PMPP",     label: "PMPP"         },
            {id: "SNMP_UDP", label: "SNMP via UDP" },
            {id: "SNMP_TCP", label: "SNMP via TCP" }
        ]

        const generatePreview = async () => {

            $scope.willGeneratePreviewSpeedLimit     = $scope.messageBoard.radar.hasOwnProperty("speedLimitMulti")
            $scope.willGeneratePreviewLegalSpeed     = $scope.messageBoard.radar.hasOwnProperty("legalSpeedMulti")
            $scope.willGeneratePreviewOverSpeed      = $scope.messageBoard.radar.hasOwnProperty("overSpeedMulti")
            $scope.willGeneratePreviewExcessiveSpeed = $scope.messageBoard.radar.hasOwnProperty("excessiveSpeedMulti")

            if ($scope.willGeneratePreviewSpeedLimit || $scope.willGeneratePreviewLegalSpeed || $scope.willGeneratePreviewOverSpeed || $scope.willGeneratePreviewExcessiveSpeed) {
                $scope.previewController = await messagePreviewService.getController($scope.messageBoard)
            }

            if ($scope.willGeneratePreviewSpeedLimit) {
                messagePreviewService.generatePreviewFromMulti($scope.previewController, $scope.messageBoard.radar.speedLimitMulti, "previewContainerSpeedLimit")
            }
            if ($scope.willGeneratePreviewLegalSpeed) {
                messagePreviewService.generatePreviewFromMulti($scope.previewController, $scope.messageBoard.radar.legalSpeedMulti, "previewContainerLegalSpeed")
            }
            if ($scope.willGeneratePreviewOverSpeed) {
                messagePreviewService.generatePreviewFromMulti($scope.previewController, $scope.messageBoard.radar.overSpeedMulti, "previewContainerOverSpeed")
            }
            if ($scope.willGeneratePreviewExcessiveSpeed) {
                messagePreviewService.generatePreviewFromMulti($scope.previewController, $scope.messageBoard.radar.excessiveSpeedMulti, "previewContainerExcessiveSpeed")
            }
        }

        const updateForms = () => {

            $scope.activeUseInWZ    = $scope.messageBoard.device.active_use_in_wz
            $scope.inEnabledWZ      = $scope.messageBoard.device.in_enabled_wz
            $scope.disableDOTAccess = $scope.messageBoard.device.disable_dot_access

            $scope.enableAlerts = $scope.messageBoard.alerts_enabled

            $scope.generalFormData = {
                name:        $scope.messageBoard.name,
                customer_id: $scope.messageBoard.device.customer_id
            }

            $scope.connectionFormData = {
                transport:      $scope.messageBoard.connection.transport,
                ip:             $scope.messageBoard.connection.ip,
                port:           $scope.messageBoard.connection.port,
                community_name: $scope.messageBoard.community_name,
                deactivated:    $scope.messageBoard.deactivated
            }
        }

        $scope.toggleActiveUseInWZ = () => {

            if ($scope.inEnabledWZ || $scope.disableDOTAccess) { return }

            $scope.activeUseInWZ = !$scope.activeUseInWZ

            const failure = () => {

                $scope.activeUseInWZ = !$scope.activeUseInWZ

                let message = "Activate"

                if ($scope.activeUseInWZ) {
                    message = "Deactivate"
                }

                userMessagingService.error("Failed to " + message + " Use In WZ. If this issue persists, please contact Wanco Support for assistance.")

            }

            devicesService.setActiveUseInWZ($scope.messageBoard.device.id, $scope.activeUseInWZ, undefined, failure)

        }

        $scope.toggleDisableDOTAccess = () => {

            if ($scope.activeUseInWZ || $scope.inEnabledWZ) { return }

            $scope.disableDOTAccess = !$scope.disableDOTAccess

            const failure = () => {

                $scope.disableDOTAccess = !$scope.disableDOTAccess

                let message = "Enable"

                if ($scope.disableDOTAccess) {
                    message = "Disable"
                }

                userMessagingService.error("Failed to " + message + " DOT Access. If this issue persists, please contact Wanco Support for assistance.")

            }

            devicesService.setDisableDOTAccess($scope.messageBoard.device.id, $scope.disableDOTAccess, undefined, failure)

        }

        $scope.getTransportDisplay = (id) => {
            for (let i = 0; i < $scope.transportOptions.length; i++) {
                if ($scope.transportOptions[i].id.toLowerCase() === ("" + id).toLowerCase()) {
                    return $scope.transportOptions[i].label
                }
            }
        }

        /**
            Edit message board general
         **/
        $scope.editMessageBoardGeneral = () => {
            $scope.submitted = true
            if ($scope.editGeneralForm.$valid) {

                const success = (data) => {

                    userMessagingService.success("General Info Edit Successful")

                    if ($scope.messageBoard.name !== data.name) {
                        $rootScope.messageBoardName = data.name
                        $scope.messageBoard.name    = data.name
                    }
                    if ($scope.messageBoard.device.customer_id !== data.device.customer_id) {
                        $scope.messageBoard.device.customer_id = data.device.customer_id
                        // $scope.getCustomer(data.device.customer_id)
                    }

                    $scope.isEditGeneral = false
                }

                const failure = (error) => {
                    userMessagingService.error(error)
                }

                const ignoreDuplicateIPs = true

                messageBoardsService.editMessageBoard($stateParams.message_board_id, angular.fromJson($scope.generalFormData), ignoreDuplicateIPs, success, failure)
            }
        }

        $scope.toggleActivated = () => {
            $scope.connectionFormData.deactivated = !$scope.connectionFormData.deactivated
        }

        $scope.editMessageBoardConnection = () => {

            if ($scope.messageBoard.meta.isWzOutput) {
                userMessagingService.error("Message Board is Read Only")
                return
            }

            $scope.submitted = true

            if ($scope.editConnectionForm.$valid) {

                const success = (data) => {

                    $scope.ignoreDuplicateIPs = false

                    if (data !== undefined && data.hasOwnProperty("has_duplicate_devices") && data.has_duplicate_devices) {

                        $uibModal.open({
                            templateUrl: "app/modals/duplicate-device-ip-modal.view.html",
                            controller:  "DuplicateDeviceIpModalController",
                            resolve: {
                                duplicateDevices: function() {
                                    return data.duplicate_devices
                                },
                                createDuplicate: () => {
                                    return () => {
                                        $scope.ignoreDuplicateIPs = true
                                        $scope.editMessageBoardConnection()
                                    }
                                },
                                actionText: () => {
                                    return "Update Device"
                                }
                            }
                        }).result.catch(function(res) {

                            $scope.ignoreDuplicateIPs = false

                            if (!(res === "cancel" || res === "escape key press")) {
                                throw res
                            }
                        })

                        return

                    }

                    userMessagingService.success("Connection Edit Successful")

                    $scope.messageBoard.connection.transport = $scope.connectionFormData.transport
                    $scope.messageBoard.connection.ip        = $scope.connectionFormData.ip
                    $scope.messageBoard.connection.port      = $scope.connectionFormData.port
                    $scope.messageBoard.community_name       = $scope.connectionFormData.community_name
                    $scope.messageBoard.deactivated          = $scope.connectionFormData.deactivated

                    $scope.editConnection = false

                }

                const failure = (error) => {

                    $scope.ignoreDuplicateIPs = false

                    if(error.hasOwnProperty("data")) {
                        if(error.data.hasOwnProperty("errors")) {
                            angular.forEach(error.data.errors, (value, key) => {
                                if(key == "conn.ip") {
                                    userMessagingService.error("Connection IP " + value + ".", true)
                                    $scope.editConnectionForm.ip.$invalid = true
                                } else if(angular.isNumber(key)) {
                                    userMessagingService.error(value + ".")
                                } else {
                                    userMessagingService.error(key + " " + value + ".")
                                }
                            })
                        }
                    } else {
                        userMessagingService.error("Connection Edit Failed")
                    }
                }

                messageBoardsService.editMessageBoard($stateParams.message_board_id, angular.fromJson($scope.connectionFormData), $scope.ignoreDuplicateIPs, success, failure)
            }
        }

        $scope.toggleEnableAlerts = () => {

            $scope.enableAlerts = !$scope.enableAlerts

            messageBoardsService.setEnableAlerts($stateParams.message_board_id, $scope.enableAlerts, undefined, () => {
                $scope.enableAlerts = !$scope.enableAlerts
                let message = "Enable"
                if ($scope.enableAlerts) {
                    message = "Disable"
                }
                userMessagingService.error("Failed to " + message + " Alerts. If this issue persists, please contact Wanco Support for assistance.")
            })
        }

        /**
            Refresh message board settings
         **/
        $scope.refreshMessageBoardSettings = () => {

            if (!$scope.isRequesting) {

                $scope.setRequesting(true)

                telemetryService.refreshSettings(
                    "MessageBoard",
                    $stateParams.message_board_id,
                    () => {
                    },
                    (error) => {
                        if (error.status !== 409) {
                            $scope.setRequesting(false)
                            userMessagingService.error(error)
                        } else {
                            userMessagingService.info("There is a background operation in progress, please wait.")
                        }
                    }
                )
            }
        }

        $scope.$on('$destroy', () => {
            userMessagingService.dismissInfo()
        })

        const notesClearNew = () => {
            $scope.notesAddNew         = false
            $scope.notesAddNewPrivate  = false
            $scope.notesNewText        = ""
            $scope.notesNewTextPrivate = ""
        }

        const notesUpdateDisplay = (notes) => {

            notes.sort((a, b) => { return a.created_at < b.created_at })

            $scope.messageBoard.device.notes         = notes
            $scope.messageBoard.device.notes_public  = $scope.messageBoard.device.notes.filter((n) => { return !n.private })
            $scope.messageBoard.device.notes_private = $scope.messageBoard.device.notes.filter((n) => { return n.private })

            setTimeout(() => {
                $scope.$apply(() => {
                    for (const note of $scope.messageBoard.device.notes) {
                        const elem = document.getElementById("noteContent" + note.id)
                        if (elem) {
                            elem.innerHTML = notesService.formatContentForDisplay(note.text)
                        }
                    }
                })
            }, 1)
        }

        $scope.notesShowAddNew = (priv) => {
            if (priv) {
                $scope.notesNewTextPrivate = ""
                $scope.notesAddNewPrivate  = true
            } else {
                $scope.notesNewText = ""
                $scope.notesAddNew  = true
            }
        }

        $scope.notesSave = (priv, text) => {

            if (priv && !$rootScope.can('SystemNotePrivateCreate', $scope.messageBoard.device.customer_id)) {
                return
            }

            const success = (notes) => {
                notesClearNew()
                notesUpdateDisplay(notes)
            }

            const failure = () => {
                notesClearNew()
                userMessagingService.error("Create Note Failed")
            }

            notesService.createNote($scope.messageBoard.device.id, "Device", text, priv, success, failure)

        }

        $scope.notesDelete = (noteID) => {

            const success = (notes) => {
                notesUpdateDisplay(notes)
            }

            const failure = () => {
                userMessagingService.error("Delete Note Failed")
            }

            notesService.deleteNote(noteID, success, failure)

        }

        $scope.$watch("$root.pushedData", async (pushedData) => {

            if (pushedData.device.hasOwnProperty("device") && $scope.messageBoard.hasOwnProperty("device")) {

                if (pushedData.device.device.id === $scope.messageBoard.device.id) {

                    updateForms()
                    await generatePreview()

                }
            }
        })

        $scope.$watch("retrievedMessageBoard", async (retrievedMessageBoard) => {

            if (retrievedMessageBoard) {
                updateForms()
                notesUpdateDisplay($scope.messageBoard.device.notes)
                await generatePreview()
            }
        })
    }
})()
